export var AttestationRecordStatus;
(function (AttestationRecordStatus) {
    AttestationRecordStatus["Attested"] = "attested";
    AttestationRecordStatus["Expired"] = "expired";
    AttestationRecordStatus["NotAttested"] = "not_attested";
    AttestationRecordStatus["NotRequired"] = "not_required";
    AttestationRecordStatus["Pending"] = "pending";
})(AttestationRecordStatus || (AttestationRecordStatus = {}));
//# sourceMappingURL=attestation-record-status.js.map